import {InputHTMLAttributes, useCallback, useEffect, useState} from "react";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";
import useModal from "./useModal";
import { KYCDocumentInterface } from "../../../domain/Folder/KYCControl";
import { SubscriberInterface } from "../../../domain/CustomerInfoRecall/CustomerInfoRecallGatewayInterface";
import MoralPerson from "../integrationState/partials/MoralPerson";
import PhysicalPerson from "../integrationState/partials/PhysicalPerson";

interface IPreviewModal {
    id: string,
    kyc: KYCDocumentInterface,
    hide?: () => void;
    className?: string;
    subscriber?: SubscriberInterface|undefined|null
}


const PreviewKYCModal = ({ id, kyc, hide, className, subscriber } :IPreviewModal) => {
    const { t } = useTranslation()
    const [isPreviewDocument, togglePreviewDocument] = useModal();

    const handleHide = useCallback(() => {
        togglePreviewDocument()
        if (hide) {
            hide()
        }
    }, [])

    const moralPersonContent = (kyc.person?.siret || kyc.person?.legalForm) ? (
        <>
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Raison sociale:</span> : <span className={`u-text-size-s`}>{kyc.person?.legalname ?? 'N/A'}</span>
            </div>
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Siret:</span> : <span className={`u-text-size-s`}>{kyc.person?.siret ?? 'N/A'}</span>
            </div>
            <div className="col-md-12">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Statut juridique:</span> : <span className={`u-text-size-s`}>{kyc.person?.legalForm ?? 'N/A'}</span>
            </div>
            <div className="col-md-12">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Adresse </span> : <span className={`u-text-size-s`}>{kyc.person?.metadata?.fulladdress ?? 'N/A'}</span>
            </div>

        </>
    ) : (
        <></>
    );

    const errors = kyc.errors?.length  ? (
        <>
            <div className="col-md-12">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Erreurs :</span>
            </div>
            <ul>
            {kyc.errors.map((error) => {
                return <li>{t(`kyc.error.${error}`)}</li>
            })}
            </ul>
        </>
    ) : ( <></> )
    const physicalPersonContent = (!kyc.person?.siret && !kyc.person?.legalForm) ? (
        <>
            {kyc.person?.metadata?.fullname ? (
                <div className="col-md-12">
                    <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Nom complet</span> : <span className={`u-text-size-s`}>{kyc.person.metadata.fullname}</span>
                </div>
            ) : (
                <>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Nom</span> : <span className={`u-text-size-s`}>{kyc.person?.lastname ?? 'N/A'}</span>
                    </div>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Prénom</span> : <span className={`u-text-size-s`}>{kyc.person?.firstname ?? 'N/A'}</span>
                    </div>
                </>
            )}
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Nom d'usage</span> : <span className={`u-text-size-s`}>{kyc.person?.maidenname ?? 'N/A'}</span>
            </div>
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Nationalité</span> : <span className={`u-text-size-s`}>{kyc.person?.nationality ?? 'N/A'}</span>
            </div>
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Date de naissance</span> : <span className={`u-text-size-s`}>{kyc.person?.birthDate ?? 'N/A'}</span>
            </div>
            <div className="col-md-6">
                <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Lieu de naissance</span> : <span className={`u-text-size-s`}>{kyc.person?.birthPlace ?? 'N/A'}</span>
            </div>
            { kyc.person?.metadata?.fulladdress ? (
                <div className="col-md-12">
                    <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Adresse </span> : <span className={`u-text-size-s`}>{kyc.person.metadata.fulladdress}</span>
                </div>
            ) : (
                <>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Rue </span> : <span className={`u-text-size-s`}>{kyc.person?.address?.street ?? 'N/A'}</span>
                    </div>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Code Postal</span> : <span className={`u-text-size-s`}>{kyc.person?.address?.zipcode ?? 'N/A'}</span>
                    </div>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Ville</span> : <span className={`u-text-size-s`}>{kyc.person?.address?.city ?? 'N/A'}</span>
                    </div>
                    <div className="col-md-6">
                        <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Pays</span> : <span className={`u-text-size-s`}>{kyc.person?.address?.country ?? 'N/A'}</span>
                    </div>
                </>
            )}
        </>
    ) : (
        <></>
    )
    const subscriberInfo = (subscriber) ? (
        <div className="col-md-12">
            <h3 className="h5 u-mbs">{t('validation.customer-info-recall')}</h3>
            {subscriber?.isMoralPerson ? <MoralPerson subscriber={subscriber} showTitle={false}/> : <PhysicalPerson subscriber={subscriber} cosubscriber={null}  showTitle={false}/>}
        </div>
    ) : (
        <></>
    )
    return (
        <Modal title={t('modal.kyc.title')}
            description={''}
            customClassName={className ?? `modal`}
            hide={handleHide}
            loading={false}>
            <div className={`flex-container padding`}>
                {subscriberInfo}
                <div className="col-md-12">
                    <h3 className="h5 u-mbs">{t('modal.kyc.extract-title')}</h3>
                    <span className={`u-txt-bold u-txt-underline u-txt-size-s`}>Document</span> : <span className={`u-text-size-s`}>{kyc.type ?? ''}</span>
                </div>
                {physicalPersonContent}                
                {moralPersonContent}
                {errors}
            </div>
        </Modal>
    )
}

export default PreviewKYCModal;
